import { Icon } from '@/common/components/Icon'
import { PageTitle } from '@/components'
import { Button, Modal } from '@/components/ui'
import { cn } from '@/lib/utils'

interface MessageBoxProps {
  isError: boolean
  message: string
  setShowMessageBox: (sM: boolean) => void
  showMessageBox: boolean
}

export const MessageBox = (props: MessageBoxProps): JSX.Element => {
  const { isError, message, showMessageBox, setShowMessageBox } = props

  const handleClose = () => {
    setShowMessageBox(false)
  }

  return (
    <Modal
      open={showMessageBox}
      onOpenChange={setShowMessageBox}
      size="sm"
      contentClassName="p-0 border-2 border-monochrome-120"
      title={
        <div className="flex items-center gap-4">
          <div
            className={cn(
              'h-[44px] w-[44px] rounded-full',
              'bg-monochrome-5 backdrop-blur-md',
              'border-2 border-monochrome-120',
              'flex items-center justify-center',
              'shadow-[0_12px_40px_rgba(0,0,0,0.45)]',
            )}
          >
            <div
              className={cn(
                'h-[40px] w-[40px] rounded-full',
                'shadow-[0_0_24px_rgba(136,100%,51%,0.35)]',
                'flex items-center justify-center',
                !isError ? 'text-accent-1' : 'text-accent-3',
              )}
            >
              <Icon
                icon={isError ? 'warning' : 'check'}
                width={isError ? '18' : '16'}
                height={isError ? '18' : '16'}
                viewBox={isError ? '0 0 18 18' : '0 0 16 16'}
                fill="none"
              />
            </div>
          </div>
          <h2 className="text-title-xxs text-monochrome-1 font-bold">
            {isError ? 'ERROR' : 'SUCCESS!'}
          </h2>
        </div>
      }
    >
      <div className="text-monochrome-1 text-title-xxs">{message}</div>
      <div className="flex w-full items-center gap-2 justify-end mt-4 border-t border-monochrome-120 pt-4">
        <Button
          onClick={handleClose}
          variant={isError ? 'destructive' : 'secondary'}
          className="w-full"
        >
          Done
        </Button>
      </div>
    </Modal>
  )
}
